export default __webpack_public_path__ + "static/media/arrow_link_left.625aacf2.svg";